//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import vueSeamlessScroll from 'vue-seamless-scroll';
export default {
  name: 'imgList',
  components: {
    vueSeamlessScroll: vueSeamlessScroll
  },
  props: {
    option: Object,
    component: Object
  },
  computed: {
    borderImageSource: function borderImageSource() {
      return this.option.borderImageSource || '/img/border/border1.png';
    },
    styleName: function styleName() {
      return {
        marginBottom: (this.option.marginBottom || 20) + 'px',
        borderImageSource: 'url(' + this.borderImageSource + ')'
      };
    },
    defaultOption: function defaultOption() {
      return {
        step: this.option.step,
        // 数值越大速度滚动越快
        limitMoveNum: this.dataChart.length,
        hoverStop: this.option.hoverStop,
        // 是否开启鼠标悬停stop
        direction: 1,
        // 0向下 1向上 2向左 3向右
        openWatch: true,
        // 开启数据实时监控刷新dom
        singleHeight: 0,
        // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0,
        // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)

      };
    }
  },
  methods: {}
};